<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    @if (show_succes == false) {
      <div class="close-dialog" mat-dialog-close>
        <span class="material-symbols-outlined">close</span>
      </div>
    }
  </div>
</div>



<mat-dialog-content>

  <div style="text-align: center;">

    <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
      @if (!show_succes) {
        <span><span class="material-symbols-outlined" style="font-size: 65px; color: var(--simpli-primary);">warning</span></span>
      }
      @if (show_succes) {
        <span><span class="material-symbols-outlined" style="font-size: 65px; color: #3BA46F;">check_circle</span></span>
      }
    </div>


    @if (deletefacturas == true) {
      <div class="delete-title">{{titledelete}}</div>
    }

    <div class="label-dialog" [innerHTML]="title"></div>
    <div class="label-dialog" [innerHTML]="subtitle"></div>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="btn-simpli-container">
          @if (deletefacturas == false) {
            <button class="primary-button" (click)="close()" mat-flat-button>
              Descartar
            </button>
          }

          @if (deletefacturas == false) {
            <button class="secondary-button" mat-flat-button mat-dialog-close>
              Cancelar
            </button>
          }

          @if (deletefacturas == true && show_succes == false) {
            <button class="primary-button" mat-dialog-close
              mat-flat-button>
              Cancelar
            </button>
          }

          @if (deletefacturas == true && show_succes == false) {
            <button [disabled]="loading_delete"
              class="secondary-button" mat-flat-button (click)="delete_factura()">
              @if (loading_delete == false) {
                <span>Eliminar factura</span>
              }
              @if (loading_delete == true) {
                <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
              }
            </button>
          }


          <!-- Botones para onboarding = true y accion = 2 -->
          @if (deletefacturas == true && show_succes == true && onboarding == true && accion == 2) {
            <button
              class="primary-button" mat-flat-button (click)="agregar_factura_onboarding()">
              Agregar factura
            </button>
          }

          @if (deletefacturas == true && show_succes == true && onboarding == true && accion == 2) {
            <button
              class="secondary-button" mat-flat-button (click)="continuar_incorporacion()">
              Continuar mi incorporación
            </button>
          }

          <!-- Botones para otros casos -->
          @if (deletefacturas == true && show_succes == true && !(onboarding == true && accion == 2)) {
            <button
              class="primary-button" mat-flat-button (click)="volver_simular()">
              Volver a simular
            </button>
          }

          @if (deletefacturas == true && show_succes == true && !(onboarding == true && accion == 2)) {
            <button
              class="secondary-button" mat-flat-button mat-dialog-close routerLink="/home/">
              Volver al inicio
            </button>
          }
        </div>

      </div>
    </div>

  </div>



</mat-dialog-content>